<div class="flag">
  <img [src]="country.flags.png" alt="Flag of {{ country.name.common }}">
</div>
<div class="content">
  <h2>{{ country.name.common }}</h2>
  <ul>
    <li><span>Population:</span> {{ country.population | number }}</li>
    <li><span>Region:</span> {{ country.region }}</li>
    <li><span>Capital:</span> {{ country.capital }}</li>
  </ul>
</div>
